@if (invoice) {
  <section class="user-details center-layout">
    <div class="form-central__content form_content">
      <h4 class="heading__4">{{ invoice.name }}</h4>
      <p>
        Invoice reference: <span class="invoice-ref">#{{ invoice.code }}</span>
      </p>
      <div class="invoice-details mt-4">
        <h6 class="heading__6">Invoice Details</h6>
        <div class="flexed justify-content-between pb-2 bdr-bottom">
          <div>
            <p>
              <span>To: </span> <span>{{ invoice.customerName }}</span>
            </p>
          </div>
          <div>
            <p>
              <span>Due date: </span
                ><span>{{ invoice.dueDate | date : "shortDate" }}</span>
              </p>
            </div>
          </div>
          <div class="invoice-products pt-4 pb-4 bdr-bottom">
            @for (product of invoice.products; track product) {
              <div
                class="invoice-product flexed justify-content-between mb-2"
                >
                <span class="text-bold__600">{{ product.name }}</span>
                <span
                  >NGN {{ product.price | number : "1.2-2" }} x {{ product.quantity }}
                </span>
              </div>
            }
          </div>
          <div class="amount flexed justify-content-between mt-3">
            <p>Amount Due</p>
            <p class="text-bold__700 heading__5">
              NGN {{ totalAmount | number : "1.2-2" }}
            </p>
          </div>
          <div>
            <b>Notes</b> <br />
            <p class="text__small no-margin-b">
              {{ invoice.note }}
            </p>
          </div>
          <div
            class="flexed justify-content-sm-end no-margin-l no-margin-r mt-3 btn_container"
            >
            <!-- <button class="btn btn-print no-margin-l invoice-btn">
            Print Invoice
          </button> -->
          <button
            class="btn btn__primary ml-2 no-margin-r invoice-btn"
            (click)="makePayment()"
            >
            Pay this invoice
          </button>
        </div>
      </div>
    </div>
  </section>
}
